var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(45 5.609 12.654)",
    x: -0.391,
    y: 11.454,
    width: 12,
    height: 2.4,
    rx: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "scale(1 -1) rotate(45 38.134 0)",
    x: 5.006,
    y: 8.049,
    width: 21.6,
    height: 2.4,
    rx: 1.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedBlack);
export default __webpack_public_path__ + "static/media/checked-black.8aaa89d9960031bdd5b90291299c5e48.svg";
export { ForwardRef as ReactComponent };